import apiClient from '../config/api';

const messagingService = {
  /** List current user's conversations with last message preview */
  getConversations: async () => {
    const response = await apiClient.get('/messaging/conversations');
    return response.data; // Expected: [{ conversationId, subject, lastMessage: { body, sentAt, senderName }, unreadCount, participants: [] }]
  },

  /** Create a new conversation */
  createConversation: async ({ participantIds, subject }) => {
    const response = await apiClient.post('/messaging/conversations', { participantIds, subject });
    return response.data;
  },

  /** Paginated messages in a conversation */
  getMessages: async (conversationId, { page = 1, pageSize = 50 } = {}) => {
    const response = await apiClient.get(`/messaging/conversations/${conversationId}/messages`, {
      params: { page, pageSize },
    });
    return response.data; // Expected: { items: [{ messageId, senderId, senderName, body, sentAt }], totalCount }
  },

  /** Send a message */
  sendMessage: async (conversationId, body) => {
    const response = await apiClient.post(`/messaging/conversations/${conversationId}/messages`, { body });
    return response.data;
  },

  /** Mark conversation as read */
  markConversationRead: async (conversationId) => {
    const response = await apiClient.post(`/messaging/conversations/${conversationId}/read`);
    return response.data;
  },

  /** Total unread count across all conversations */
  getUnreadCount: async () => {
    const response = await apiClient.get('/messaging/unread-count');
    return response.data; // Expected: { count: number }
  },
  
  /** Permanently delete a conversation */
  deleteConversation: async (conversationId) => {
    const response = await apiClient.delete(`/messaging/conversations/delete/${conversationId}`);
    return response.data;
  },
};

export default messagingService;
